import { Quote } from 'components/Quote'
import { ReactNode } from 'react'

const url = window.location.href
console.log(url)
export const content_gesellschaft: {
  title: string
  author: string
  autorBio: string
  content: ReactNode
  link?: number
}[] = [
  {
    title: 'Wie Weihnachten feiern inmitten der Energiekrise?',
    author: 'Denise Jeitziner',
    autorBio: '95007130/denise-jeitziner',
    content: (
      <>
        <p>
          Weihnachten ist vor allem eins: von allem viel zu viel. Oder anders
          gesagt: Nie könnte man einfacher Energie und CO2 sparen. Erst recht in
          Zeiten, in denen sich Klimaaktivisten auf den Asphalt kleben,
          «Strommangellage» zum Wort des Jahres gekürt und die Lämplischam
          erfunden worden ist: Wer sein Zuhause heuer mit Lichterketten
          schmückt, rückt sich in eine ungute Nähe zu jenen Mitbürgerinnen und
          Mitbürgern, die noch sorglos Flüge buchen.
        </p>
        <p>
          Wir könnten also zum Beispiel komplett auf die Beleuchtung verzichten
          – oder zumindest auf LED-Lichterketten setzen. Diese verbrauchen im
          Schnitt zehnmal weniger Energie als herkömmliche. Oder Kerzen anzünden
          – aber nur solche aus Bienenwachs, denn für jene aus Paraffin gehen
          riesige Flächen Regenwald drauf.
        </p>
        <Quote>
          Wir brauchen Licht und Wärme in unserem Leben! Vor allem zu
          Weihnachten.
        </Quote>
        <p>
          Der Weihnachtsbaum – wenn es unbedingt einer sein muss – ist am besten
          gemietet, am zweitbesten in der Region gefällt. Ein künstlicher hat
          nur dann eine bessere Ökobilanz, wenn er mindestens 17 Jahre im
          Einsatz ist. Und schliesslich: das Festmahl. Vegan wäre es am
          umweltfreundlichsten, gefolgt vom Poulet- und Schweinefleisch;
          Biorindfleisch schneidet aus ökologischer Sicht am schlechtesten ab.
        </p>
        <p>
          Halten wir uns diese Ökoweihnachten mal kurz vor Augen: Wir singen
          «Du-u-nkle Nacht, hei-lige Nacht» im finsteren, 19 Grad kühlen
          Wohnzimmer, in dem ein geleaster Christbaum steht, und dazu gibt es
          Linseneintopf, weil der 18-mal weniger Treibhausgase verursacht als
          ein Steak. Nichts gegen Linsen, aber der Rest ist doch deprimierend.
        </p>
        <p>
          Wir brauchen Licht und Wärme in unserem Leben! Von aussen und von
          innen. Vor allem zu Weihnachten. Also lasst uns die Lichterketten
          rausholen und dem Überfluss frönen. Sparen können wir ab dem 27.
          Dezember wieder.
        </p>
      </>
    ),
    link: url.includes('tagesanzeiger') ? 511131831511 : undefined,
  },
  {
    title: 'Wie viele biologische Geschlechter gibt es?',
    author: 'Michèle Binswanger',
    autorBio: '91350405/michele-binswanger',
    content: (
      <>
        <p>
          So leidenschaftlich heutzutage über die Frage gestritten wird, wie
          viele biologische Geschlechter es gibt, so einfach ist die Antwort
          darauf: Es gibt zwei davon, nicht mehr und nicht weniger. In der
          Biologie definiert man Geschlecht danach, welche Rolle ein Organismus
          in der geschlechtlichen Fortpflanzung spielt. Lebewesen, die
          Samenzellen produzieren, sind männlich – und zwar egal, ob es sich
          dabei um Pflanzen, Tiere oder Menschen handelt. Und Lebewesen, welche
          Eizellen produzieren, sind weiblich.
        </p>
        <p>
          Dabei spielt es keine Rolle, welches Lebewesen die Frucht austrägt,
          das Ei ausbrütet oder, wie bei den Pflanzen, aus einer Blüte eine
          Frucht entsteht. Und es spielt auch keine Rolle, ob ein Organismus
          Eizelle und Samen gleichzeitig produziert. In diesem Fall spricht man
          von Zwitter oder Hermaphroditen, beide gelten biologisch aber nicht
          als drittes Geschlecht. Biologisch gibt es zwei Geschlechter und
          fertig.
        </p>
        <Quote>
          Dies ist allerdings keine biologische, sondern eine psychosoziale
          Frage.
        </Quote>

        <p>
          Nun ist diese Aussage in gewissen Kreisen höchst umstritten. Wer
          solches behaupte, sei transphob, heisst es, und spreche Transmenschen
          ihre Identität, ja ihre Existenzberechtigung ab. Das ist Humbug und
          liegt daran, dass meist nicht sauber unterschieden wird, ob wir nun
          von biologischem Geschlecht (sex) oder sozialem Geschlecht (gender)
          sprechen.
        </p>
        <p>
          Anatomisch, psychologisch und physiologisch existiert ein breites
          Spektrum von Geschlechtervariationen. Bei einigen Tieren, so auch beim
          Menschen, gibt es X- und Y-Chromosomen, die in der Regel das
          Geschlecht definieren, also dafür sorgen, dass Männer zum Beispiel
          Bartwuchs haben und Frauen eine Gebärmutter und Brüste. Allerdings
          gibt es hier Ausnahmen, etwa Personen mit einem Y-Chromosom, die
          trotzdem weibliche Genitalien entwickeln. Und manche Menschen haben
          sowohl Eierstock- wie auch Hodengewebe, man spricht dann von
          Intersexualität.
        </p>
        <p>
          Und wenn wir noch weiter gehen und nach der geschlechtlichen Identität
          fragen, öffnet sich ein breites Spektrum von Geschlechtervariationen,
          zu denen auch Fluide, Nonbinäre und Trans-Identitäten gehören. Dies
          ist allerdings keine biologische, sondern eine psychosoziale Frage.
        </p>
      </>
    ),
    link: 955053029345,
  },
  {
    title: 'Ist die Generation Z arbeitsfaul?',
    author: 'Lisa Füllemann',
    autorBio: '79545900/lisa-fullemann',
    content: (
      <>
        <p>
          Faul, verwöhnt, anspruchsvoll und realitätsfremd – mit diesen
          Adjektiven wird die Generation Z von Arbeitgebenden und Medien gerne
          denunziert und schubladisiert. Die Menschen, die zwischen 1997 und
          2012 geboren sind, legten zu viel Wert auf Freizeit und vertrügen
          keine Kritik. Doch wenn man diese Behauptungen in Gen-Z-Sprache
          übersetzt, wünschen sich junge Menschen einfach eine ausgewogene
          Work-Life-Balance und ein gutes Arbeitsklima. Was genau soll daran
          verwerflich sein? Vor allem in einer Zeit, in der psychischer
          Gesundheit endlich mehr Beachtung geschenkt wird, sollten solche
          Anliegen mehr Gewicht haben.
        </p>
        <p>
          Tatsächlich hat die Generation Z miterlebt, wie Eltern in ihrem Umfeld
          an ihrer Arbeit und am Druck zerbrachen und in einer Burn-out-Klinik
          wieder gesund werden mussten. Es ist aber auch eine Generation, die
          sich inmitten von Klimakrise, Pandemie und Krieg in einem
          Dauerkrisenzustand befindet. Dass dabei die Arbeit in den Hintergrund
          und das eigene Wohlbefinden in den Vordergrund rückt, ist in solchen
          Zeiten nicht verwunderlich und zudem ein gesamtgesellschaftlicher
          Trend.
        </p>
        <Quote>
          Die älteren Generationen sollten die Generation Z wegen ihrer
          progressiven Vorschläge nicht verteufeln.
        </Quote>
        <p>
          Gut also, dass die selbstbewusste Generation Z gelernt hat, Grenzen zu
          setzen und nicht verhandelbare Bedingungen zu stellen – auch in der
          Arbeitswelt. Dass klassische Arbeitsstrukturen zudem gar nicht so
          starr sind und zum Vorteil vieler aufgelöst werden können, hat uns die
          Corona-Pandemie gezeigt. Anstatt jeden Tag ins Büro zu gehen, arbeiten
          selbst nach dem Lockdown viele Menschen weiterhin gerne im Homeoffice.
          Sodom und Gomorrha ist deswegen nicht eingetroffen – vielmehr machen
          uns flexible Arbeitsmodelle mitunter produktiver und sogar
          glücklicher, wie mehrere Studien gezeigt haben.
        </p>
        <p>
          Die älteren Generationen sollten die Generation Z also wegen ihrer
          progressiven Vorschläge nicht verteufeln. Und stattdessen versuchen,
          die jungen Menschen zu verstehen und zu integrieren. Und als Chance zu
          sehen, am Arbeitsplatz gesunde Veränderungen herbeizuführen.
        </p>
      </>
    ),
    link: 824002842473,
  },
  {
    title: 'Darf eine weisse Person Dreadlocks tragen?',
    author: 'Alexandra Kedves',
    autorBio: '59641494/alexandra-kedves',
    content: (
      <>
        <p>
          Kurze Antwort: Nein. Zumindest müssen weisse Menschen mit Rastas seit
          diesem Sommer auch in der Schweiz mit Vorwürfen oder schrägen Blicken
          rechnen – international ist das Thema bereits seit Jahren unter dem
          Schlagwort «Kulturelle Aneignung» auf dem Tapet, und das nicht zu
          Unrecht. Im Sommer kam es nun in einem Berner Lokal zum
          Konzertabbruch, als Schweizer Reggae-Musiker mit den für ihr
          Musikgenre typischen Rastalocken auftraten. Als Nachschlag gabs ein
          Riesenbohei in den Medien, und viele tadelten die Entscheidung der
          Veranstalter. Wenig später wurde in Zürich das Konzert eines
          österreichischen Musikers vorauseilend abgesagt, ebenfalls wegen
          seiner Rastafrisur.
        </p>
        <p>
          Lange Antwort: Es ist kompliziert. Stellen wir die Frage mal anders.
          Mal unabhängig davon, wie gerechtfertigt oder übertrieben die Absagen
          waren: Warum brachten diese die Leute so sehr in Rage?
        </p>
        <p>
          Beide Vorfälle boten eine Steilvorlage für die angesagte Kritik des
          «Woke-Wahnsinns». Dieses Bashing machte 2022 einen grossen Anteil des
          Debattenjahrs aus. Drei Beispiele: Die schwarze Meerjungfrau in der
          neuen Disney-Verfilmung von «Arielle», geplant für 2023, führte schon
          vorab zu Geheul. Auch der Rückzug zweier «Winnetou»-Kinderbücher durch
          den Ravensburger-Verlag wurde zum Untergang des Abendlandes
          hochstilisiert und die Trans-Barbie zum satanisch-woken
          Sexualisierungsversuch unserer Kinder.
        </p>
        <Quote>
          Ironischerweise erleben wir durch die «woken» Forderungen nicht den
          Untergang des Abendlandes, sondern dessen grösste Errungenschaft.
        </Quote>
        <p>
          Die Argumente sind bekannt: «Wokeness» gefährde die Freiheit. Es
          herrsche eine Diktatur von links, umgekehrter Rassismus und
          LGBTQ-Dominanz machten sich breit in der Kultur, den Medien, in
          Arbeitsleben und Alltag, Universitäten und Schulen. Früher schimpfte
          man über die «politische Korrektheit», jetzt über den «Woke-Wahnsinn».
        </p>
        <p>
          Das Gejammer darüber lenkt treffsicher von echten gesellschaftlichen
          Problemen ab – und auch von der langen Geschichte struktureller
          Minderheitenunterdrückung. Und, ironischerweise, erleben wir durch die
          «woken» Forderungen auch nicht den Untergang des Abendlandes, sondern,
          im Gegenteil, dessen grösste Errungenschaft: die emanzipatorische
          Kraft der Aufklärung und das Empowerment eines jeden Menschen.
        </p>
        <p>
          Auf der anderen Seite scheint sich der Anspruch auf Sensibilität teils
          zu radikalisieren – was der guten Sache nicht dient, im Gegenteil. Da
          werden manchmal «verletzte Gefühle» und «Sich-unwohl-Fühlen» zum
          Totschlagargument; dies leistet dem Eindruck einer übertriebenen
          «Cancel-Culture» Vorschub. So hat etwa die Idee, dass
          Schauspielerinnen und Schauspieler im Grunde nicht mehr darstellen
          dürfen, sondern «sein» müssen, durchaus problematische Seiten: Soll
          nur ein Schwuler einen Schwulen darstellen dürfen? Darf er handkehrum
          nie einen Hetero spielen? Wohin führt so ein identitätspolitischer
          Fokus?
        </p>
        <Quote>
          Vielleicht würde Ihnen jemand dann von den Rastafari erzählen.
        </Quote>
        <p>
          Grundsätzlich ist es freilich richtig, behutsam und reflektiert mit
          Kulturmerkmalen diskriminierter Gruppen umzugehen. Darum fragen Sie
          doch – um auf die Rasta-Frage zurückzukommen – erst mal nicht: Wo
          bleibt die Freiheit der (Haar-)Kunst? Sondern fragen Sie: Wie kann es
          sein, dass eine Haartracht, die schon bei den Wikingern und den
          Bronzezeit-Kretern bekannt war, solche Kränkungen verursacht?
        </p>
        <p>
          Vielleicht würde Ihnen jemand dann von den Rastafari erzählen, einer
          religiösen, Afrika-orientierten Gruppe, die in den 1930ern auf Jamaica
          entstand und sich gegen die Unterdrückung durch die weissen,
          post-kolonialistischen Strukturen wehrte; die Rasta-Frisur, für die
          sie sich auf die Bibel berufen, steht für diesen Widerstand. Zudem
          wurden Nicht-Weisse für ebendiese Haartracht geächtet; die
          «Dread(lock)s» heissen offenbar so, weil britische Kolonialisten sie
          «dreadful» (schrecklich) fanden.
        </p>
        <p>
          Wenn sich Weisse, also strukturell privilegierte Personen, diese
          Haarkunst, die eine Geschichte der Unterdrückung erzählt, spielerisch
          und ohne Nachdenken zu eigen machen, kann das durchaus verletzend
          wirken. Es lohnt sich also, vor einem Woke-Bashing solche Hintergründe
          näher zu betrachten. Und sich, im vorliegenden Fall, zu fragen: Wieso
          genau möchte ich diese Frisur tragen?
        </p>
      </>
    ),
    link: 697915639026,
  },
  {
    title: 'Ist die Pandemie jetzt vorbei?',
    author: 'Marc Brupbacher',
    autorBio: '83371228/marc-brupbacher',
    content: (
      <>
        <p>
          Die Pandemie ist aus den Köpfen der meisten Schweizerinnen und
          Schweizer tatsächlich verschwunden. Gemäss dem aktuellen
          CS-Sorgenbarometer machen sich nur noch 13 Prozent der Bevölkerung
          Gedanken wegen der Pandemie. Gesundheitsbehörden und die Politik
          schweigen das Coronavirus seit Frühling praktisch tot. Beenden kann
          die Pandemie aber offiziell nur die Weltgesundheitsorganisation.
        </p>
        <p>
          Unabhängig davon ist es eine verdrängte Tatsache, dass Sars-CoV-2
          weiterhin bedeutende Gesundheitsschäden anrichtet. Der Berner
          Epidemiologe Christian Althaus sagt: «Ob man es nun Pandemie oder
          Endemie nennt, das Virus wird weiter zirkulieren und verursacht durch
          Long Covid und kardiovaskuläre Folgekomplikationen ein ernsthaftes
          chronisches Gesundheitsproblem, das zu erheblicher Morbidität und
          Mortalität führt.»
        </p>
        <Quote>
          Die Pandemie hat sich zu einer chronischen Belastung für die
          Volksgesundheit entwickelt.
        </Quote>
        <p>
          Dieses Jahr war geprägt von übervollen Notfallpraxen, erschöpftem
          Pflegepersonal, anhaltend hoher Übersterblichkeit, abgesagten
          Konzerten, beeinträchtigten Sportveranstaltungen, eingestellten
          Tramlinien. Auch 2022 sorgte Covid als gewichtiger Faktor für eine
          dauerhafte Belastung des Gesundheitswesens und immer wieder für
          Störungen des öffentlichen Lebens.
        </p>
        <p>
          Die Kombination aus neuen Sars-CoV-2-Varianten, zügig schwindender
          Immunität und aufgehobenen Massnahmen hat 2022 zu mehreren
          unberechenbaren Infektionswellen geführt. Das Jahr ist noch nicht ganz
          vorbei, aber gemäss unserer Datenauswertung lässt sich jetzt schon
          sagen, dass Covid 2022 für die Gesellschaft punkto Hospitalisationen,
          Übersterblichkeit und Langzeitschäden eine ähnlich grosse
          Gesundheitsbelastung darstellte wie in den beiden Vorjahren. Die
          Pandemie hat sich von einem akuten Ereignis zu einer chronischen und
          schleichenden Belastung für die Volksgesundheit entwickelt.
        </p>
        <Quote>
          Gelernt hat in der Schweiz kaum jemand etwas. Masken tragen nur noch
          Vereinzelte, im Tram wird übel gehustet.
        </Quote>
        <p>
          Zusätzlich muss das durch insgesamt neun Corona-Wellen arg
          angeschlagene Gesundheitswesen nun obendrauf mit all den anderen
          viralen und bakteriellen Krankheiten kämpfen, die mit den
          weggefallenen Corona-Massnahmen wuchtig zurückkehrten. Problematisch
          ist vor allem die Gleichzeitigkeit mehrerer Erregerwellen. Die
          Belastung in den Spitälern ist enorm. Der Krankenstand so hoch wie
          selten zuvor, was auch den Schulbetrieb erschwert und die
          Privatwirtschaft immer wieder in Bedrängnis bringt. Und an die
          Vulnerablen denkt schon lange niemand mehr.
        </p>
        <p>
          Es hiess oft, dass man als Gesellschaft lernen müsse, mit dem Virus zu
          leben. Gelernt hat in der Schweiz aber kaum jemand etwas. Masken
          tragen nur noch Vereinzelte, im Tram wird übel gehustet, Eltern
          schicken ihre kranken Kinder wieder wie vor der Pandemie in die
          Schule, weil sie arbeiten müssen, impfen liess sich mit dem
          Herbst-Booster in der Schweiz nur noch jeder vierte Rentner. Und die
          meisten Schülerinnen und Schüler sitzen immer noch in miserabel
          belüfteten Klassenzimmern.
        </p>
        <p>
          Das Coronavirus hat seinen grossen Schrecken zwar verloren. Doch
          vorbei ist es nicht.
        </p>
      </>
    ),
    link: 676350321220,
  },
]
